












































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator'
import { FindTituloUseCase, SaveTituloUseCase } from '@/usecases/titulos'
import DatePicker from '@/components/ui/DatePicker.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { Titulo, TipoDePessoa, Usuario, DetalhesPagamentoEmCheque, CentroDeCusto } from '@/models'
import {
	FluxoDoTitulo,
	FormaDePagamento,
	FormDeTitulo,
	Loja,
	Parcelamento,
	SituacaoDoTitulo,
	TipoDePagamento,		
} from '@/models'
import { maiorOuIgualAZero, obrigatorio } from '@/shareds/regras-de-form'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import { criarTitulo } from '@/shareds/titulo'
import { calcularAbasDeTitulo } from '@/shareds/abas-de-titulo'
import { FindBaixaDePagamentoUseCase } from '@/usecases'
import type { DetalhesPagamentoEmChequeServiceAdapter, PagamentoServiceAdapter } from '@/usecases'
import { BaixaDePagamento, BaixaDePagamentoAuditada } from '@/models/financeiro/BaixaDePagamento'
import axios, { CancelTokenSource } from 'axios'
import { DataOptions } from 'vuetify'
import { dateTimeToPtBrFormat, dateToPtBrFormat } from '@/shareds/date/date-utils'
import DialogoDeEdicaoDeBaixasDePagamento from './DialogoDeEdicaoDeBaixasDePagamento.vue'
import { DeleteBaixaDePagamentoUseCase } from '@/usecases/baixaDePagamento/DeleteBaixaDePagamentoUseCase'
import { formatarCnpjOuCpf, formatarMoeda } from '@/shareds/formatadores'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { imprimirComprovanteDeRecebivelComTef } from '@/shareds/venda-shareds'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import { extrairCnpjOuCpfDaPessoa } from '@/shareds/cliente-shareds'
import SeletorDeFornecedorComBusca from '@/components/fornecedor/SeletorDeFornecedorComBusca.vue'
import { UpdateBaixaDePagamentoUseCase } from '@/usecases/baixaDePagamento/UpdateBaixaDePagamentoUseCase'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import DialogoDeEdicaoDeEstornoDePagamentosDosTitulos from './DialogoDeEdicaoDeEstornoDePagamentosDosTitulos.vue'
import { Inject } from 'inversify-props'
import { FindCentroDeCustoUseCase } from '@/usecases/titulos/FindCentroDeCustoUseCase'

type TipoDeAcao = 'edicao' | 'criacao';
type AbaDeTitulo<T extends TipoDeAcao> = T extends 'edicao'
  ? 'Principal' | 'Configuração Crediário' | 'Erros'
  : 'Baixas' | 'Erros';
@Component({
	components: {
		DatePicker,
		CampoDecimal,
		SeletorDeLojas,
		DialogoDeEdicaoDeBaixasDePagamento,
		Confirmacao,
		SeletorDeFornecedorComBusca,
		SeletorDeCliente,
		DialogoDeEdicaoDeEstornoDePagamentosDosTitulos,
	},
})
export default class DialogoDeEdicaoDeTitulo extends Vue {
	@Prop() tipoDePessoa!: TipoDePessoa
	@Prop({ type: Boolean, default: false }) retornoCrediario!: boolean
	@Ref() form!: HTMLFormElement
	@Ref() campoDeLoja!: HTMLInputElement
	@Ref() dialogoDeBaixas!: DialogoDeEdicaoDeBaixasDePagamento
	@Ref() dialogoDeEstorno!: DialogoDeEdicaoDeEstornoDePagamentosDosTitulos
	@Ref() confirmacaoDeDeletarBaixa!: Confirmacao
	formulario: FormDeTitulo = criarTitulo('Entrada')
	@Prop() titulo!: Titulo
	@Ref() menu!: {
		save: (value?: any) => void
	}

	obrigatorio = obrigatorio
	formatarMoeda = formatarMoeda
	maiorOuIgualAZero = maiorOuIgualAZero

	opcoesDeSituacaoDeTitulo: SituacaoDoTitulo[] = [
		'Aberto',
		'Cancelado',
		'Estornado',
		'Pago',
	]

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Cartão',
		'Dinheiro',
		'Voucher',
		'Crediário',
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
		'Link',
		'Outros',
		'Cheque',
		'Boleto',
		'Pix',
	]

	opcoesDeFormaDePagamentoDaBaixa: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	buscando = false
	mostra = false
	show = false

	edicaoFormaPagamento = true
	mostraMenuHoras = false
	modo = 'baixa'
	selecionado: BaixaDePagamento | null = null

	saveTituloUseCase = new SaveTituloUseCase()
	findBaixaDePagamento = new FindBaixaDePagamentoUseCase()
	cancelToken: CancelTokenSource | null = null
	deleteBaixasUseCase = new DeleteBaixaDePagamentoUseCase()
	updateBaixaUseCase = new UpdateBaixaDePagamentoUseCase()
	findTituloUseCase = new FindTituloUseCase()
	@Inject('DetalhesPagamentoEmChequeServiceAdapter')
	private detalhesPagamentoEmChequeService!: DetalhesPagamentoEmChequeServiceAdapter
	@Inject('PagamentoServiceAdapter')
	private pagamentoService!: PagamentoServiceAdapter
	findCentroDeCustoUseCase = new FindCentroDeCustoUseCase()

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	baixasDePagamento: BaixaDePagamentoAuditada[] = []
	tab: null | number = null
	tabs: AbaDeTitulo<TipoDeAcao>[] = []
	dialogKey = 0
	tituloParaBaixa: Titulo | null = null
	recalculando = false
	disabled = false
	fornecedorCadastrado = false
	horas = ''
	data = ''
	detalhesPagamentoEmCheque: DetalhesPagamentoEmCheque | null = null
	tipoDeAcao: TipoDeAcao[] = []
	tipoDeDesconto: 'valorFixo' | 'porcentagem' = 'valorFixo'
	centrosDeCustoDaLoja: CentroDeCusto[] = []

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	parcelamento: Parcelamento = {
		quantidade: 2,
		recorrencia: 30,
		diaDoVencimento: null,
	}

	get headers() {
		const colunas = [
			{ text: 'Forma de Pagamento', value: 'formaDePagamento' },
			{ text: 'Data do Movimento', value: 'dataDoMovimentoFormatada', sortable: false },
			{ text: 'Data da Baixa', value: 'dataHoraPagamentoFormatada', sortable: false },
			{ text: 'Total Pago', value: 'valorTotalPago' },
			{ text: 'Total Desconto', value: 'valorTotalDesconto' },
			...(this.formulario.fluxo === 'Saída'
				? [{ text: 'Acréscimo', value: 'valorAcrescimoFormatado', sortable: false }]
				: []),
			{ text: 'Usuario Lançamento', value: 'usuarioRecebimento.nome' },
			{ text: 'Taxa', value: 'isTaxa' },
			{ text: 'Operador', value: 'nomeDoOperador' },
			{ text: 'Ações', value: 'actions', sortable: false },
		]
		return colunas
	}

	headersSemActions = [
		{ text: 'Transação', value: 'transactionId' },
		{ text: 'Valor Pago', value: 'valorPagamento' },
		{ text: 'Usuario Lançamento', value: 'usuarioRecebimento.nome' },
		{ text: 'Operador', value: 'nomeDoOperador' },
		{ text: 'Taxa', value: 'isTaxa' },
	]

	get temAcessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	get permitirAlterarDataBaixa() {
		return UserLoginStore.permiteRegraDeNegocio('permitir-alteracao-data-pagamento')
	}

	get baixasDePagamentoFormatados() {
		return this.baixasDePagamento
			.filter(baixa => baixa.tipoDeTransacao === 'Baixa' || baixa.tipoDeTransacao === null)
			.map(baixa => ({
				...baixa,
				id: baixa.id,
				transactionId: baixa.transactionId,
				valorPagamento: baixa.valorPagamento,
				dataHoraPagamentoFormatada: dateTimeToPtBrFormat(baixa.dataHoraPagamento),
				isTaxa: baixa.isTaxa,
				isIntegracao: baixa.isIntegracao,
				fechamentoDeCaixaAuditado: baixa.fechamentoDeCaixaAuditado,
				editandoFormaDePagamento: false,
				editandoDataDoPagamento: false,
				dataDoMovimentoFormatada: dateToPtBrFormat(baixa.created_at),
				nomeDoOperador: baixa.usuarioRecebimento ? baixa.usuarioRecebimento.nome : '--',
				estornado: baixa.estornado,
				tipoDeTransacao: baixa.tipoDeTransacao,
				valorJurosSobreBaixa: baixa.valorJurosSobreBaixa,
				valorDaMultaSobreBaixa: baixa.valorDaMultaSobreBaixa,
				valorTotalPago:
					'R$' + formatarMoeda(Number((baixa.valorPagamento || 0) +
					(baixa.valorJurosSobreBaixa || 0) +
					(baixa.valorDaMultaSobreBaixa || 0))),
				valorTotalDesconto: this.calcularValorTotalDesconto(baixa),
				valorAcrescimoFormatado: baixa.valorAcrescimo ? 'R$' + formatarMoeda(Number(baixa.valorAcrescimo)) : '-',
			}))
	}

	get estornoDeBaixasDePagamentoFormatados() {
		return this.baixasDePagamento
			.filter(baixa => baixa.tipoDeTransacao === 'Estorno')
			.map(baixa => ({
				...baixa,
				id: baixa.id,
				transactionId: baixa.transactionId,
				valorPagamento: baixa.valorPagamento,
				dataHoraPagamentoFormatada: dateTimeToPtBrFormat(baixa.dataHoraPagamento),
				isTaxa: baixa.isTaxa,
				isIntegracao: baixa.isIntegracao,
				fechamentoDeCaixaAuditado: baixa.fechamentoDeCaixaAuditado,
				editandoFormaDePagamento: false,
				editandoDataDoPagamento: false,
				dataDoMovimentoFormatada: dateToPtBrFormat(baixa.dataHoraPagamento),
				nomeDoOperador: baixa.usuarioRecebimento ? baixa.usuarioRecebimento.nome : '--',
				estornado: baixa.estornado,
				tipoDeTransacao: baixa.tipoDeTransacao,
				valorJurosSobreBaixa: baixa.valorJurosSobreBaixa,
				valorDaMultaSobreBaixa: baixa.valorDaMultaSobreBaixa,
				valorTotalPago:
					'R$' + formatarMoeda(Number(baixa.valorPagamento || 0) +
					(baixa.valorJurosSobreBaixa || 0) +
					(baixa.valorDaMultaSobreBaixa || 0)),
				valorTotalDesconto: this.calcularValorTotalDesconto(baixa),
				valorAcrescimoFormatado: baixa.valorAcrescimo ? 'R$' + formatarMoeda(Number(baixa.valorAcrescimo)) : '-',
			}))
	}

	/**
	 * Armadilhas deste computed, todas mantidas de propósito. Nenhuma delas foi corrigida aqui:
	 *
	 * 1. É um computed que ESCREVE estado (this.tabs) enquanto é lido. A DECISÃO de quais abas
	 *    existem saiu para calcularAbasDeTitulo, em src/shareds/abas-de-titulo.ts, que é função
	 *    pura e tem teste de tabela congelando as 72 combinações de entrada. Aqui ficou só o
	 *    efeito colateral, no mesmo lugar de antes.
	 *
	 * 2. O @Watch logo abaixo aponta para um GETTER, não para um método, e por isso não funciona:
	 *    o vue-property-decorator registra o watcher com o nome 'abasPermitidas' e o Vue resolve
	 *    vm['abasPermitidas'], que é o VALOR do computed (um array), não uma função. Quando
	 *    formulario.formaDePagamento muda, o Vue tenta chamar esse array como callback e cai no
	 *    tratador de erro dele. O watcher não faz nada de útil, mas também não é inofensivo: essa
	 *    resolução acontece na inicialização do componente e avalia o computed uma vez, o que já
	 *    escreve this.tabs. Por isso ele continua aqui, e não foi removido junto do resto do
	 *    código morto: remover mudaria o momento da primeira avaliação.
	 *
	 * 3. Quando nenhum ramo casa (tipoDeAcao[0] é undefined até a primeira chamada de
	 *    mostrarDialogo), as abas ficam nas anteriores. A função pura reproduz isso devolvendo a
	 *    mesma referência recebida, e a atribuição abaixo vira um no-op na reatividade do Vue.
	 *
	 * A diferença de acento entre 'Crediário' e 'Crediario' nos ramos, que faz o título de Saída
	 * perder a aba de crediário, está explicada em src/shareds/abas-de-titulo.ts.
	 */
	@Watch('formulario.formaDePagamento')
	get abasPermitidas() {
		this.tabs = calcularAbasDeTitulo({
			formaDePagamento: this.formulario.formaDePagamento,
			tipoDeAcao: this.tipoDeAcao[0],
			fluxo: this.formulario.fluxo,
			// perfilTemRegraDeNegocio devolve `string | false`, nao boolean, e o codigo original
			// usava esse valor direto num ternario. O `!!` reproduz exatamente a mesma decisao,
			// inclusive para string vazia, que e falsy nos dois casos.
			temAcessoIrrestrito: !!this.temAcessoIrrestrito,
			abasAtuais: this.tabs,
		})

		return this.tabs
	}


	async imprimirComprovante(baixa: BaixaDePagamento) {
		try {
			const usuarioRecebimento = baixa.usuarioRecebimento as unknown as Usuario
			
			const baixaFormatada: BaixaDePagamento = {
				id: baixa.id,
				titulo: baixa.titulo,
				transactionId: baixa.transactionId,
				valorPagamento: baixa.valorPagamento,
				dataHoraPagamento: baixa.dataHoraPagamento,
				isTaxa: baixa.isTaxa,
				isIntegracao: baixa.isIntegracao,
				tipoDeTransacao: baixa.tipoDeTransacao,
				estornado: baixa.estornado,
				usuarioRecebimento: usuarioRecebimento ? usuarioRecebimento.id : '',
				valorJurosSobreBaixa: baixa.valorJurosSobreBaixa,
				valorDaMultaSobreBaixa: baixa.valorDaMultaSobreBaixa,
				valorDeDescontoNosJuros: 0,
				valorDeDescontoNaMulta: 0,
				tipoDeDesconto: this.tipoDeDesconto,
			}

			const pdf = await this.findBaixaDePagamento.imprimirBaixaDePagamento(baixaFormatada)

			await imprimirComprovanteDeRecebivelComTef(pdf, await this.comprovantesDoTefDaBaixa(baixa))
		} catch(error) {
			AlertModule.setError(error)
		}

	}

	async comprovantesDoTefDaBaixa(baixa: BaixaDePagamento): Promise<string[]> {
		if (!baixa.detalhesDoPagamentoId) return []

		const detalhes = await this.pagamentoService.buscarDetalhesDoPagamento(baixa.detalhesDoPagamentoId)

		return [detalhes.comprovanteAdquirente, detalhes.comprovanteLoja]
			.filter((comprovante): comprovante is string => !!comprovante)
	}

	async updateBaixaPagamento(baixa: BaixaDePagamentoAuditada) {
		if(!baixa) return

		const dataHora = `${this.data}T${this.horas}`
		const baixaDePagamento: BaixaDePagamento = {
			...baixa,
			dataHoraPagamento: dataHora,
			usuarioRecebimento: baixa.usuarioRecebimento.id,
		}

		try {
			await this.updateBaixaUseCase.updateBaixaDePagamento(baixaDePagamento)
			baixa.editandoDataDoPagamento = false
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.buscarBaixas()
		}
	}

	esconder(){
		this.baixasDePagamento = []
		this.mostra = false
		this.modo = 'baixa'
	}

	atualizaBaixas(baixa: BaixaDePagamento) {
		this.buscarBaixas()
		this.$emit('atualizar')
		this.$emit('valor', baixa)
		this.limparDados()
		this.mostra = false
	}

	exibeConfirmacao(item: BaixaDePagamento | null) {
		if(!item) return
		this.selecionado = JSON.parse(JSON.stringify(item))
		this.confirmacaoDeDeletarBaixa.mostrar()
		
	}

	async buscarBaixas() {
		if (this.cancelToken) this.cancelToken.cancel()

		try {
			this.buscando = true
			this.cancelToken = axios.CancelToken.source()
			const params = {
				tituloId: this.formulario.id,
				page: this.paginacao.page,
				size: this.paginacao.itemsPerPage,
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const page = await this.findBaixaDePagamento.findByTituloId(
				params,
				axiosConfig,
			)
			this.baixasDePagamento = page.content
			this.paginacao.itemsPerPage = 5

			this.buscando = false
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.buscando = false
		}
	}

	mostrarDialogo(titulo: Titulo | FluxoDoTitulo, condicao: string, tipoDeAcao: TipoDeAcao) {
		this.dialogKey++
		this.limparDados()
		this.edicaoFormaPagamento = condicao == 'criar' ? false : true
		this.mostra = true
		this.modo = 'baixa'
		this.tipoDeAcao = [tipoDeAcao]
		if (typeof titulo !== 'string') {
			this.tituloParaBaixa = titulo as Titulo
		}

		this.formulario =
			typeof titulo === 'string'
				? criarTitulo(titulo)
				: {
					...titulo,
					formaDePagamento: titulo.formaDePagamento
						? this.displayPagamento(titulo.formaDePagamento)
						: '',
					id: titulo.id ? titulo.id : '',
					tipoDePagamento: titulo.tipoDePagamento,
				}
		setTimeout(() => {
			this.campoDeLoja.focus()
		}, 250)
		if(this.edicaoFormaPagamento == true) this.buscarBaixas()

		!this.formulario.pessoa ? this.fornecedorCadastrado = false : this.fornecedorCadastrado = true
	}

	changeEditandoDataDoPagamento(item: BaixaDePagamentoAuditada) {
		const idx = this.baixasDePagamentoFormatados.findIndex(baixa => baixa.id === item.id)
		this.baixasDePagamentoFormatados[idx].editandoDataDoPagamento = !item.editandoDataDoPagamento

		if (item.dataHoraPagamento) {
			const [data, horaComMs] = item.dataHoraPagamento.split('T')
			const horas = horaComMs.split('.')[0]
			this.data = data
			this.horas = horas
		}
	}

	displayPagamento(formaDePagamento: string) {
		let formaFormatada
		if (formaDePagamento == 'CARTAO') formaFormatada = 'Cartão'
		if (formaDePagamento == 'DINHEIRO') formaFormatada = 'Dinheiro'
		if (formaDePagamento == 'VOUCHER') formaFormatada = 'Voucher'
		if (formaDePagamento == 'OUTROS') formaFormatada = 'Outros'
		if (formaDePagamento == 'TEF CREDITO') formaFormatada = 'TEF Crédito'
		if (formaDePagamento == 'TEF DEBITO') formaFormatada = 'TEF Débito'
		if (formaDePagamento == 'CREDIARIO') formaFormatada = 'Crediario'
		if (formaDePagamento == 'CHEQUE') formaFormatada = 'Cheque'
		if (formaDePagamento == 'BOLETO') formaFormatada = 'Boleto'
		if (formaDePagamento == 'PIX') formaFormatada = 'Pix'
		return formaFormatada
	}

	get valorFaltante() {		
		if (this.tituloParaBaixa && this.baixasDePagamento && this.tituloParaBaixa.id) {
			return this.tituloParaBaixa.valorAtualizado
		}
		return 0
	}

	abrirDialogoDeCriacaoDeBaixa() {
		const valorFaltante = this.valorFaltante ?? 0;
		this.dialogoDeBaixas.mostrarDialogo(this.tituloParaBaixa, valorFaltante, false);
	}

	abrirDialogoDeEdicaoDeBaixa(item: BaixaDePagamento) {
		const valorFaltante = this.valorFaltante ?? 0;
		this.dialogoDeBaixas.mostrarDialogo(this.tituloParaBaixa, valorFaltante, true, item);
	}

	calcularDisponivelParaEstorno(baixa: BaixaDePagamentoAuditada): number {
		const estornosVinculados = this.baixasDePagamento.filter(
			b => b.tipoDeTransacao === 'Estorno' && (b.baixaDePagamentoOrigemId === baixa.id),
		)

		const totalBaixa = Math.abs(baixa.valorPagamento || 0) +
			Math.abs(baixa.valorJurosSobreBaixa || 0) +
			Math.abs(baixa.valorDaMultaSobreBaixa || 0) +
			Math.abs(baixa.valorDesconto || 0) +
			Math.abs(baixa.valorDeDescontoNosJuros || 0) +
			Math.abs(baixa.valorDeDescontoNaMulta || 0)

		const totalJaEstornado = estornosVinculados.reduce((acc, e) =>
			acc + Math.abs(e.valorPagamento || 0) +
			Math.abs(e.valorJurosSobreBaixa || 0) +
			Math.abs(e.valorDaMultaSobreBaixa || 0) +
			Math.abs(e.valorDesconto || 0) +
			Math.abs(e.valorDeDescontoNosJuros || 0) +
			Math.abs(e.valorDeDescontoNaMulta || 0), 0)

		return Math.max(0, totalBaixa - totalJaEstornado)
	}

	abrirDialogoDeEstornoDeBaixa(baixa: BaixaDePagamentoAuditada){
		const estornosVinculados = this.baixasDePagamento.filter(
			b => b.tipoDeTransacao === 'Estorno' && b.baixaDePagamentoOrigemId === baixa.id,
		)

		const jaEstornadoPagamento = estornosVinculados.reduce((acc, e) => acc + Math.abs(e.valorPagamento || 0), 0)
		const jaEstornadoJuros = estornosVinculados.reduce((acc, e) => acc + Math.abs(e.valorJurosSobreBaixa || 0), 0)
		const jaEstornadoMulta = estornosVinculados.reduce((acc, e) => acc + Math.abs(e.valorDaMultaSobreBaixa || 0), 0)
		const jaEstornadoDescontoJuros = estornosVinculados.reduce((acc, e) => acc + Math.abs(e.valorDeDescontoNosJuros || 0), 0)
		const jaEstornadoDescontoMulta = estornosVinculados.reduce((acc, e) => acc + Math.abs(e.valorDeDescontoNaMulta || 0), 0)
		const jaEstornadoDeDescontoNoTitulo = estornosVinculados.reduce((acc, e) => acc + Math.abs(e.valorDesconto || 0), 0)

		const totalValorBaixa = !baixa.isTaxa ? Math.max(0, Math.abs(baixa.valorPagamento || 0) - jaEstornadoPagamento) : 0
		const totalValorTaxa = baixa.isTaxa ? Math.max(0, Math.abs(baixa.valorPagamento || 0) - jaEstornadoPagamento) : 0
		const totalValorDesconto = Math.max(0, Math.abs(baixa.valorDesconto || 0) - jaEstornadoDeDescontoNoTitulo)
		const valorJurosSobreBaixa = Math.max(0, Math.abs(baixa.valorJurosSobreBaixa || 0) - jaEstornadoJuros)
		const valorDaMultaSobreBaixa = Math.max(0, Math.abs(baixa.valorDaMultaSobreBaixa || 0) - jaEstornadoMulta)
		const totalValorDescontoJuros = Math.max(0, Math.abs(baixa.valorDeDescontoNosJuros || 0) - jaEstornadoDescontoJuros)
		const totalValorDescontoMulta = Math.max(0, Math.abs(baixa.valorDeDescontoNaMulta || 0) - jaEstornadoDescontoMulta)

		const valorValidoParaEstornos = !baixa.isTaxa ? totalValorBaixa : totalValorTaxa

		if (valorValidoParaEstornos + valorDaMultaSobreBaixa + valorJurosSobreBaixa + totalValorDescontoMulta + totalValorDescontoJuros + totalValorDesconto <= 0) {
			AlertModule.setError('Sem valores de baixa para estornar!')
			return
		}

		const titulo: Titulo = {
			...this.formulario,
			id: this.formulario.id ?? '',
			numero: 0,
			sequencia: 0,
			serie: null,
			situacao: {} as SituacaoDoTitulo,
			temParcelamento: false,
			tipoDePagamento: this.formulario.tipoDePagamento ?? {} as TipoDePagamento,
			valor: this.formulario.valor ? Number(this.formulario.valor) : 0,
			dataDeVencimento: this.formulario.dataDeVencimento ?? '',
			dataDeCompetencia: this.formulario.dataDeCompetencia ?? '',
		}

		const totalValorDisponivel = valorJurosSobreBaixa + valorDaMultaSobreBaixa + totalValorDescontoJuros + totalValorDescontoMulta

		this.dialogoDeEstorno.mostrarDialogo(valorValidoParaEstornos, titulo, totalValorBaixa, totalValorDesconto, totalValorTaxa, valorJurosSobreBaixa, valorDaMultaSobreBaixa, totalValorDescontoJuros, totalValorDescontoMulta, totalValorDisponivel, baixa.id)
	}

	async salvarTitulo() {
		try {
			this.disabled = true
			if (!this.form.validate()) return
			if (!this.formulario) return

			if (this.detalhesPagamentoEmCheque && this.formulario.tipoDePagamento?.formaDePagamento === 'Cheque'){
				await this.detalhesPagamentoEmChequeService.criarPagamentoEmCheque(this.detalhesPagamentoEmCheque)
			}
			
			const titulos = await this.saveTituloUseCase.execute(this.formulario, this.parcelamento)

			this.$emit('salvar', titulos)
			this.formulario = criarTitulo('Entrada')
			this.baixasDePagamento = []
			this.mostra = false
		} catch (e) {
			AlertModule.setError(e)
			this.disabled = false
		} finally{
			this.disabled = false
			this.modo = 'baixa'
		}
	}

	async salvarFormaDePagamento(item: BaixaDePagamentoAuditada) {
	
		if(!item) return
		if(!item.formaDePagamento) return
		try {
			await this.updateBaixaUseCase.update(item.id, item.formaDePagamento)
			item.editandoFormaDePagamento = false;
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async recalcularTitulo() {
		if (!this.formulario.id || this.recalculando) return
		this.recalculando = true
		try {
			await this.findTituloUseCase.recalcularTitulo(this.formulario.id)
			const titulo = await this.findTituloUseCase.findById(this.formulario.id)
			this.formulario = {
				...titulo,
				formaDePagamento: titulo.formaDePagamento
					? this.displayPagamento(titulo.formaDePagamento)
					: '',
				id: titulo.id ? titulo.id : '',
				tipoDePagamento: titulo.tipoDePagamento,
			}
			AlertModule.setSuccess('Recálculo realizado com sucesso!')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.recalculando = false
		}
	}

	async removerBaixa(baixa: BaixaDePagamento | null) {
		if (!baixa) return

		try {
			await this.deleteBaixasUseCase.execute(baixa.id)
			this.baixasDePagamento = this.baixasDePagamento.filter(
				({ id }) => id !== baixa.id,
			)

			this.formulario.id = this.formulario.id ?? ''; 

			const titulo = await this.findTituloUseCase.findById(this.formulario.id);

			if (
				(titulo.formaDePagamento === 'CREDIARIO' || titulo.formaDePagamento === 'BOLETO') &&
				titulo.fluxo === 'Entrada'
			) {
				await this.saveTituloUseCase.calcularJurosDoTitulo(titulo.id)
			}

			this.formulario = {
				...titulo,
				formaDePagamento: titulo.formaDePagamento
					? this.displayPagamento(titulo.formaDePagamento)
					: '',
				id: titulo.id ? titulo.id : '',
				tipoDePagamento: titulo.tipoDePagamento,
			}
			this.$emit('aplicar')
			this.mostra = false
			this.modo = 'baixa'
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return this.tituloParaBaixa = null
		window.requestAnimationFrame(() => {
			this.form.resetValidation()
		})
		this.modo = 'baixa'
	}
	
	@Watch('formulario.formaDePagamento')
	onChangeFormulario() {
		if (this.formulario.formaDePagamento == 'Dinheiro') return this.formulario.temParcelamento = false
	}

	@Watch('formulario.loja', { immediate: true, deep: true })
	async onChangeLoja(lojaAtual: Loja | null, lojaAnterior: Loja | null) {
		if (lojaAtual && lojaAnterior !== lojaAtual) {
			this.centrosDeCustoDaLoja = await this.findCentroDeCustoUseCase.findCentroDeCustoByLojaId({lojaId: lojaAtual.id})
		}
	}

	@Watch('formulario.tipoDePagamento')
	onChangeTipoDePagamento(tipoDePagamentoAtual: TipoDePagamento | null, tipoDePagamentoAnterior: TipoDePagamento | null) {
		if (!tipoDePagamentoAtual && tipoDePagamentoAtual !== tipoDePagamentoAnterior) {
			this.formulario.formaDePagamento = null
		}

		if (tipoDePagamentoAtual && tipoDePagamentoAtual !== tipoDePagamentoAnterior) {
			this.formulario.formaDePagamento = tipoDePagamentoAtual.formaDePagamento
		}
	}
	
	@Watch('formulario.temParcelamento')
	onChangeTemParcelamento() {
		this.show = !this.show
	}

	validateDiaDoVencimento() {
		if (this.parcelamento.diaDoVencimento == null) return 
		
		if (this.parcelamento.diaDoVencimento > 31) {
			this.parcelamento.diaDoVencimento = 31;
		}
	}

	calcularValorTotalDesconto(baixa: BaixaDePagamentoAuditada): string {
		const valorDesconto = baixa.valorDesconto || 0
		const valorDescontoNosJuros = baixa.valorDeDescontoNosJuros || 0
		const valorDescontoNaMulta = baixa.valorDeDescontoNaMulta || 0
		const totalDesconto = valorDesconto + valorDescontoNosJuros + valorDescontoNaMulta
		
		return 'R$' + formatarMoeda(Number(totalDesconto.toFixed(2)))
	}
	
	get cnpjOuCpfFormatado() {
		const cnpjOuCpf = extrairCnpjOuCpfDaPessoa(this.formulario.pessoa)
		return cnpjOuCpf ? formatarCnpjOuCpf(cnpjOuCpf) : ''
	}

	limparDados() {
		this.baixasDePagamento = []
		this.tab = 0
		this.tabs = []
		this.tituloParaBaixa = null
		this.horas = ''
		this.data = ''

	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	irParaVendaOrigem(IdentificadorDaVenda: string | null){
		if (this.temRecurso('ler', 'vendas')) {
			window.open(`/vendas?identificador=${IdentificadorDaVenda}`, '_blank')
		}
	}
  
	get podeExcluirBaixasDePagamento(){
		return UserLoginStore.permiteRegraDeNegocio('pode-excluir-baixas-de-contas-a-receber')
	}

	async abrirDetalhesDoPagamentoEmCheque() {
		if (!this.formulario) return

		try {
			this.show = !this.show
			if (this.show){
				if (this.formulario.id){
					this.detalhesPagamentoEmCheque = await this.detalhesPagamentoEmChequeService.findByTituloId(this.formulario.id)
				} else {
					this.detalhesPagamentoEmCheque = {
						id: '',
						dataVencimento: null,
						banco: '',
						agencia: '',
						conta: '',
						numeroDoCheque: '',
						identificadorDaVenda: '',
					}
				}
			}
		}
		catch (error: any){
			AlertModule.setError(error)
		}
		
	}
	
	get podeAlterarDatasDeVencimentoECompetencia() {
		return UserLoginStore.permiteRegraDeNegocio('pode-alterar-data-de-vencimento-e-competencia')
	}

}
